import React, {useContext, useEffect} from "react";
import {ProductContext} from "../../../pages/ProductStencil";
import {OverlayLabel} from "./components/OverlayLabel";
import {OverlayProduct} from "./components/OverlayProduct";
import {OverlayActions} from "./components/OverlayActions";
import {OverlayCrossSell} from "./components/OverlayCrossSell";

export const BasketOverlay = () => {
    const {
        showBasketOverlay,
        setShowBasketOverlay
    } = useContext(ProductContext);

    if (!showBasketOverlay) {
        return null;
    }

    const [active, setActive] = React.useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setActive(true);
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div className={`basket-overlay ${active ? ' basket-overlay--active' : ""}`}>
            <div className="overlay-blur"
                 onClick={() => setShowBasketOverlay(false)}/>
            <div className="overlay-content">
                <OverlayLabel/>
                <OverlayProduct/>
                <OverlayCrossSell/>
                <OverlayActions/>
            </div>
        </div>
    );
}
